import React, { useState } from "react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"

import { Loader2, MoreHorizontal } from "lucide-react"
import { DataLoaPasca } from "@/types"
import Modal from "@/components/Modal"
import Form from "./Form"
import useApiBaseUrl from "@/hooks/useApiBaseUrl"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import FormHeader from "@/components/FormHeader"
import { FaFilePdf } from "react-icons/fa6"
import api from "@/lib/axios"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { AxiosError } from "axios"
import toast from "react-hot-toast"
// import { useMutation, useQueryClient } from "@tanstack/react-query";
// import api from "@/lib/axios";

const uploadLoa = async (formData: FormData) => {
  const response = await api.post("/operator-pasca/data-loa/upload", formData)
  return response.data
}

export default function Actions({ row }: { row: DataLoaPasca }) {
  const { apiBaseUrl } = useApiBaseUrl()
  const [showEdit, setShowEdit] = useState(false)
  const [showUploadFile, setShowUploadFile] = useState(false)
  const [selectedRow, setSelectedRow] = useState<DataLoaPasca | null>(null)
  const [file, setFile] = useState<File | null>(null)

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: uploadLoa,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["listDataLoa"],
      })
      toast.success(data?.message || "Success.")
      setShowUploadFile(false)
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleUploadLOA = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData()
    formData.append("id_data_loa_pasca", row.id_data_loa_pasca)
    if (file) formData.append("file", file)

    mutate(formData)
  }

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowEdit(true)
                setSelectedRow(row)
              }}
            >
              Persetujuan
            </DropdownMenuItem>
            {row.status == 1 && (
              <>
                <DropdownMenuItem
                  onClick={() => {
                    window.open(
                      `${apiBaseUrl}/operator-pasca/data-loa/generate-format-loa?id_data_pendaftaran=${row.data_pendaftaran?.id_data_pendaftaran}`,
                      "_blank"
                    )
                  }}
                >
                  Download Format
                </DropdownMenuItem>

                <DropdownMenuItem
                  onClick={() => {
                    setShowUploadFile(true)
                  }}
                >
                  Upload LOA
                </DropdownMenuItem>
              </>
            )}

            <DropdownMenuSeparator />
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal show={showEdit} onClose={() => setShowEdit(false)}>
        <Form closeModal={() => setShowEdit(false)} selectedRow={selectedRow} />
      </Modal>

      <Modal show={showUploadFile} onClose={() => setShowUploadFile(false)}>
        <FormHeader title="Upload Dokumen LOA" icon={<FaFilePdf />} />
        <form onSubmit={handleUploadLOA}>
          <div>
            <Label>Dokumen LOA</Label>
            <Input
              required
              type="file"
              onChange={(event) => {
                const files = event.target.files
                if (files && files[0]) {
                  setFile(files[0])
                }
              }}
            />
          </div>
          <div className="mt-5 flex gap-3">
            <Button
              variant={"outline"}
              onClick={() => setShowUploadFile(false)}
              disabled={isPending}
            >
              Batal
            </Button>
            <Button className="flex items-center gap-3" disabled={isPending}>
              {isPending ? (
                <>
                  <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                  Processing...
                </>
              ) : (
                "Upload"
              )}
            </Button>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  )
}
